// Runtime config shared by the auth client and API fetchers.
//
// The server lives on a different origin in production (api.oracord.com)
// from the web app (app.oracord.com), so every request must be
// credentialed (cookies) and pointed at the absolute base URL.

const viteEnv = (import.meta as ImportMeta & { env?: { VITE_API_BASE_URL?: string; VITE_ORACORD_APP_DOWNLOAD_URL?: string } }).env;

export const API_BASE_URL =
  viteEnv?.VITE_API_BASE_URL?.replace(/\/+$/, '') || 'http://localhost:3500';

export const ORACORD_APP_DOWNLOAD_URL = viteEnv?.VITE_ORACORD_APP_DOWNLOAD_URL?.trim() || '';
